export const SUMMARYLIST_REQUEST = "SUMMARYLIST_REQUEST";
export const SUMMARYLIST_SUCCESS = "SUMMARYLIST_SUCCESS";
export const SUMMARYLIST_ERROR = "SUMMARYLIST_ERROR";
export const SUMMARYLIST_params = {
    key: process.env.VUE_APP_API_KEY,
    connector: 'ILTTripSummary1',
    size: 1000,
    filter: []
};